'use strict';
module.exports = {
    buyer: false,
    typeOfTraveller: '',
    frequentFlyerList: [],
    profile: {
        gender: '',
        title: '',
        name: '',
        middleName: null,
        firstLastName: '',
        secondLastName: null,
        birthDate: null,
        prefixPhoneNumber: null,
        phoneNumber: null,
        prefixAlternatePhoneNumber: null,
        mobilePhoneNumber: null,
        alternatePhoneNumber: null,
        identificationType: null,
        identification: null,
        identificationExpirationDate: null,
        identificationCountryCode: null,
        identificationCountryCodeRes: null,
        address: {
            address: null,
            addressType: null,
            city: null,
            country: null,
            postalCode: null,
            isPrimary: true,
            alias: null,
            state: null,
        },
        cpf: null,
        nationalityCountryCode: null,
        identificationList: null,
        isDefault: false,
    },
    importedFromLocal: false,
};
